function convertHectareToAcre(num) {
  let eq =
    "Converting " +
    num +
    " hectare to acre: \n" +
    num +
    " * 2.471053815 = ";
  let rep = num * 2.471053815;
  return eq + rep.toFixed(3);
}

function convertHectareToSquareFoot(num) {
  let eq =
    "Converting " +
    num +
    " hectare to square foot: \n" +
    num +
    " * 107639.1042 = ";
  let rep = num * 107639.1042 ;
  return eq + rep.toFixed(3);
}

function convertHectareToSquareInch(num) {
  let eq =
    "Converting " +
    num +
    " hectare to square inch:  \n" +
    num +
    " * 15500031 = ";
  let rep = num * 15500031;
  return eq + rep.toFixed(2);
}

function convertHectareToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " hectare to square meter: \n" +
    num +
    " * 10000 = ";
  let rep = num * 10000;
  return eq + rep.toFixed(2);
}

function convertHectareToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " hectare to square mile: \n" +
    num +
    " * 0.003861021585 = ";
  let rep = num * 0.003861021585 ;
  return eq + rep.toFixed(5);
}

function convertHectareToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " hectare to square yard: \n" +
    num +
    " * 11959.90046 = ";
  let rep = num * 11959.90046 ;
  return eq + rep.toFixed(3);
}

export {
  convertHectareToAcre,
  convertHectareToSquareFoot,
  convertHectareToSquareInch,
  convertHectareToSquareMeter,
  convertHectareToSquareMile,
  convertHectareToSquareYard
};
